import './DashbordClient.scss';
import 'chart.piecelabel.js';

//import { CompressOutlined } from '@mui/icons-material';
//import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

//import { useContext } from 'react';
//import Chart from 'react-apexcharts';
// import { API_URI_CVTheque, getCVThequeENV } from '../../config';
//import AuthContext from '../../Contexts/AuthProvider';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useGetRequest from '../../hooks/useGetRequest';
import useRole from '../../hooks/useRole';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { adapter4BackendProxy } from '../../Utils/utilsDashboards';
import BoxesCountStatusCandidatures from '../Admin/Dashbords/BoxesCountStatusCandidatures';
import CandidaturesParAo from '../Admin/Dashbords/CandidaturesParAo';
import ChiffreAffaire from '../Admin/Dashbords/ChiffreAffaire';
import Echancier from '../Admin/Dashbords/Echancier';
import StatutCandidatures from '../Admin/Dashbords/StatutCandidatures';
import StatutCras from '../Admin/Dashbords/StatutCras';
import StatutFactures from '../Admin/Dashbords/StatutFactures';
import StatutMissions from '../Admin/Dashbords/StatutMissions';
import TotalAo from '../Admin/Dashbords/TotalAo';

//  npm install chart.piecelabel.js
//  npm install --save react-apexcharts & also Apexcharts
//* we don't use it .. :   npm install --save react-icons

function DashbordClient() {

    const axiosPrivate = useAxiosPrivate();
    //const [dataAllAos, SetDataAllAos]=useState();
    const [allStatusCandiatures,setAllStatusCandiatures]=useState();
    const [allStatusMissions,setAllStatusMissions]=useState();
    //const [allFactures,setAllFactures]=useState();
    const { i18n } = useTranslation();
    const [allCras,setAllCras]=useState();
    const [companyDataId,setCompanyDataId]=useState();
    const [collabId,setCollabId]=useState();
    const [companyName,setCompanyName]=useState();
    const [selectedBackOfficeValues, setSelectedBackOfficeValues] = useState([]);
    const [DataForCandidatureRecuParAO, SetDataForCandidatureRecuParAO] = useState();
    const { data: clientInfos } = useGetRequest({ url: 'client/getMyInfos' });
    const [chiffreAffaire,setChiffreAffaire]=useState();
    const role=useRole();
    const [roleCollab,setRoleCollab]=useState();
    const {device}=useWindowSize();
    const { setBackdropOpen} = useUtilities();

    useEffect(() =>{
        if(companyDataId)
            getDataClient();
    }, [companyDataId]);

    useEffect(()=>{
        getAllBackOffice();
    },[]);

    useEffect(() =>{
        if(clientInfos){
            setCompanyDataId(clientInfos?.collaborator?.companyDataId?._id);
            setCollabId(clientInfos?.collaborator?._id);
            setCompanyName(clientInfos?.collaborator?.companyDataId?.profileEntreprise?.nom);
            if(clientInfos?.collaborator?.roles?.Admin==1 || clientInfos?.collaborator?.roles?.littleAdmin==1)
                setRoleCollab('admin');
            else
                setRoleCollab('other');
        }
    }, [clientInfos]);

    const getAllBackOffice = async () => {
        try {
            const listBo=await adapter4BackendProxy(axiosPrivate,  'getAllListBackOffice');
            setSelectedBackOfficeValues(listBo);
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    const getDataClient = async () => {
        try {
            setBackdropOpen(true);
            const [
                allStatusCandiatures,
                allMissions,
                cras,
                chiffreAffaire,
                allCandidatures
            ] = await Promise.all([
                adapter4BackendProxy(axiosPrivate, `client/getStatusCandidatures/${encodeURIComponent(companyDataId)}/${encodeURIComponent(collabId)}/${encodeURIComponent(roleCollab)}`).catch(error => {
                    console.error('Error fetching status candidatures:', error);
                    return null;
                }),
                adapter4BackendProxy(axiosPrivate, `client/getMissions/${encodeURIComponent(companyDataId)}/${encodeURIComponent(collabId)}/${encodeURIComponent(roleCollab)}`).catch(error => {
                    console.error('Error fetching missions:', error);
                    return null;
                }),
                adapter4BackendProxy(axiosPrivate, `client/getCrasX/${encodeURIComponent(companyDataId)}/${encodeURIComponent(collabId)}/${encodeURIComponent(roleCollab)}`).catch(error => {
                    console.error('Error fetching CrasX:', error);
                    return null;
                }),
                adapter4BackendProxy(axiosPrivate, `client/getCA/${encodeURIComponent(companyDataId)}/${encodeURIComponent(collabId)}/${encodeURIComponent(roleCollab)}`).catch(error => {
                    console.error('Error fetching CA:', error);
                    return null;
                }),
                adapter4BackendProxy(axiosPrivate, `client/getTotalCandidatures/${encodeURIComponent(companyDataId)}/${encodeURIComponent(collabId)}/${encodeURIComponent(roleCollab)}`).catch(error => {
                    console.error('Error fetching total candidatures:', error);
                    return null;
                })
            ]);
            SetDataForCandidatureRecuParAO(allCandidatures);
            setAllStatusCandiatures(allStatusCandiatures);
            setAllStatusMissions(allMissions);
            console.log('allMissions allMissions',allMissions);
            setAllCras(cras);
            console.log('cras cras',cras);
            setChiffreAffaire(chiffreAffaire);
            console.log('chiffreAffaire chiffreAffaire',chiffreAffaire);
            setBackdropOpen(false);

        } catch (error) {
            console.log(error.response?.status);
        }
    };

    return (
        <div className='HomeFrame'>
            <h4 className='dashFrame13'>{i18n.t('Tableau de bord')}</h4>
            <BoxesCountStatusCandidatures
                statusCandiaturesByCompanyId={allStatusCandiatures}
                DataForCandidatureRecuParAO={DataForCandidatureRecuParAO}
                allCras={allCras}
                chiffreAffaire={chiffreAffaire}
                allStatusMissions={allStatusMissions}
                roleCollab={roleCollab}
                collabId={collabId}
            />
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',height:device=='desktop'?'425px':'auto'}}>
                <CandidaturesParAo
                    DataForCandidatureRecuParAO={DataForCandidatureRecuParAO}
                    filtreClient={false}
                    companyDataId={companyDataId}
                    width={device=='desktop' ?'50%':'100%'}
                    role={role}
                    height={device=='desktop'?'425px':'auto'}
                />

                <TotalAo
                    dataAllAos={DataForCandidatureRecuParAO}
                    filtreClient={false}
                    companyDataIdClient={companyDataId}
                    clientName={companyName}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />
            </div>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',height:device=='desktop'?'425px':'auto'}}>
                <StatutCandidatures
                    statusCandiaturesByCompanyId={allStatusCandiatures}
                    filtreClient={false}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />

                <StatutMissions
                    allStatusMissions={allStatusMissions}
                    filtreClient={false}
                    clientName={companyName}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />
            </div>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',height:device=='desktop'?'425px':'auto'}}>
                <StatutCras
                    allCras={allCras}
                    filtreClient={false}
                    role={'client'}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />

                <StatutFactures
                    allFactures={chiffreAffaire}
                    filtreClient={false}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />
            </div>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',height:device=='desktop'?'425px':'auto'}}>
                <ChiffreAffaire
                    chiffreAffaire={chiffreAffaire}
                    filtreClient={false}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />
                <Echancier
                    filtreClient={false}
                    chiffreAffaire={chiffreAffaire}
                    selectedBackOfficeValues={selectedBackOfficeValues}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />
            </div>
        </div>
    );
}

export default DashbordClient;